export default {
  init() {
    // JavaScript to be fired on all pages
    (function ($) {
      $('.banner-right').waypoint(
        function () {
          $('.banner-right').addClass('fadeInRight');
        },
        { offset: '100%' }
      );
      $('.banner-left').waypoint(
        function () {
          $('.banner-left').addClass('fadeInLeft');
        },
        { offset: '100%' }
      );
      $('.secondary-banner-top').waypoint(
        function () {
          $('.secondary-banner-top').addClass('fadeInRight');
        },
        { offset: '100%' }
      );
      $('.secondary-banner-bottom').waypoint(
        function () {
          $('.secondary-banner-bottom').addClass('fadeInLeft');
        },
        { offset: '100%' }
      );

      $(window).scroll(function () {
        $('.future-top').waypoint(
          function () {
            $('.future-top').addClass('fadeInUp');
          },
          { offset: '100%' }
        );
        $('.option-left').waypoint(
          function () {
            $('.option-left').addClass('fadeInLeft');
          },
          { offset: '100%' }
        );
        $('.option-right').waypoint(
          function () {
            $('.option-right').addClass('fadeInRight');
          },
          { offset: '100%' }
        );
        $('.services-top').waypoint(
          function () {
            $('.services-top').addClass('fadeInUp');
          },
          { offset: '100%' }
        );
        $('.services-left').waypoint(
          function () {
            $('.services-left').addClass('fadeInLeft');
          },
          { offset: '100%' }
        );
        $('.services-right').waypoint(
          function () {
            $('.services-right').addClass('fadeInRight');
          },
          { offset: '100%' }
        );
        $('.services-bottom').waypoint(
          function () {
            $('.services-bottom').addClass('fadeInUp');
          },
          { offset: '100%' }
        );
        $('.testimonial-left').waypoint(
          function () {
            $('.testimonial-left').addClass('fadeInLeft');
          },
          { offset: '100%' }
        );
        $('.testimonial-right').waypoint(
          function () {
            $('.testimonial-right').addClass('fadeInRight');
          },
          { offset: '100%' }
        );
        $('.appointment-right').waypoint(
          function () {
            $('.appointment-right').addClass('fadeInRight');
          },
          { offset: '100%' }
        );
        $('.appointment-left').waypoint(
          function () {
            $('.appointment-left').addClass('fadeInLeft');
          },
          { offset: '100%' }
        );
      });
    })(jQuery);
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js